import {StyledPageHeaderWrapper} from "../../../../../../components/calls/upcoming-calls/upcoming-calls.style";
import {StyledCreateButtonWrapper} from "../../../../../../layouts/dashboard-wrapper/dashboard-wrapper.style";
import {StyledPageHeader} from "../../../../../../styles/dashboard/calls/calls";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {CreateScheduleFormModal} from "./create-schedule-form";
import {useUserScheduleContext} from "../../context/user-schedule";

export function SchedulesHeader() {
  const {dispatch} = useUserScheduleContext();
  function handleOpenCreateScheduleModal() {
    dispatch({
      type: "toggle-create-user-schedule-modal",
      payload: true,
    });
  }
  return (
    <StyledPageHeaderWrapper>
      <StyledPageHeader style={{fontSize: "1.8rem"}}>Schedules</StyledPageHeader>
      <StyledCreateButtonWrapper>
        <Button block type="primary" size="small" onClick={handleOpenCreateScheduleModal}>
          <span className="show-desktop">Create new schedule</span>
          <span className="show-mobile">
            <PlusOutlined style={{fontSize: "2.4rem"}} />
          </span>
        </Button>
      </StyledCreateButtonWrapper>

      <CreateScheduleFormModal />
    </StyledPageHeaderWrapper>
  );
}
